import { LegalShell, Section, P, UL } from "@/components/site/Legal";
import { useConsent } from "@/components/site/ConsentManager";

export default function Cookies() {
  const { openSettings } = useConsent();
  return (
    <LegalShell
      seoTitle="Cookie Policy | Eminence Windows & Doors"
      seoDescription="What cookies and similar technologies the Eminence Windows & Doors website uses, and how to manage your preferences."
      kicker="Legal"
      title="Cookie Policy"
      updated="September 2026"
    >
      <Section>
        <P>
          This Cookie Policy explains how the Eminence Windows &amp; Doors website uses cookies and similar
          technologies (such as browser storage), and how you can control them. For more about how we handle
          personal information generally, please see our{" "}
          <a href="/privacy" className="underline hover:text-gold-deep">Privacy Notice</a>.
        </P>
        <P>
          Cookies are small files or pieces of data stored on your device. We group the technologies we use
          into the categories below.
        </P>
      </Section>

      <Section heading="Strictly necessary">
        <P>
          These are required for the website to operate and stay secure, and to remember your cookie
          choices. They are not dependent on optional consent. This includes a small amount of local
          browser storage used to remember your cookie preferences on this site.
        </P>
      </Section>

      <Section heading="Analytics">
        <P>
          We use <strong>Google Analytics 4 (GA4)</strong> (Measurement ID G-3XD9L4B4C6) to understand
          how visitors use the site — for example page views, quote call-to-action clicks, successful
          lead submissions, telephone-link clicks and email-link clicks.
        </P>
        <P>
          GA4 runs in Google's <strong>Advanced Consent Mode</strong>. If you accept analytics cookies,
          GA4 sets analytics cookies and measures your visit normally. If you decline, analytics
          cookies and storage remain disabled — but GA4 may still send limited, cookieless
          consent-mode signals that Google can use for aggregate and modelled measurement. You can
          change your choice at any time using the Cookie settings option below.
        </P>
      </Section>

      <Section heading="Marketing / advertising">
        <P>
          These cookies would be used for advertising and measuring advertising performance — for example a
          future Meta (Facebook) Pixel or similar advertising technology. No marketing or advertising
          cookies are currently installed on this website. If we add them in future, they will only run
          with your consent.
        </P>
      </Section>

      <Section heading="Managing your preferences">
        <P>
          When you first visit, our cookie banner lets you accept all cookies, reject optional cookies, or
          manage your preferences by category. Strictly necessary technologies remain enabled as they are
          essential to the site.
        </P>
        <P>
          You can change or withdraw your choice at any time using the{" "}
          <button onClick={openSettings} className="underline hover:text-gold-deep" data-testid="cookies-open-settings">
            Cookie settings
          </button>{" "}
          option, which is also available at any time via the "Cookie settings" link in the website footer.
          You can also block or delete cookies through your browser settings, though some parts of the site
          may not work as intended.
        </P>
      </Section>
    </LegalShell>
  );
}
